// SEO Content: Dormagen - Stadt und Stadtteile
// Unique, high-quality content for each location (800-1200 words)

export const seoContentDormagen = {
  // Main city page - Dormagen
  main: {
    heroTitle: "Ihr Maler in Dormagen – Lokal, Zuverlässig, Qualitätsbewusst",
    heroSubtitle: "Professionelle Malerarbeiten für Dormagen und alle Stadtteile. Von Nievenheim bis Zons – wir sind Ihr Handwerkspartner vor Ort.",
    
    mainContent: {
      intro: `Dormagen ist unsere Heimat. Als lokaler Malerbetrieb kennen wir die Stadt am Rhein wie unsere Westentasche – von der historischen Zollfeste Zons über das lebhafte Zentrum bis zu den idyllischen Ortsteilen wie Nievenheim, Horrem und Straberg. Diese Verwurzelung macht den Unterschied: Wir sind nicht irgendein Malerbetrieb, sondern Ihr Nachbar.

Die Lage zwischen Düsseldorf und Köln macht Dormagen zu einem attraktiven Wohnort für Pendler und Familien gleichermaßen. Die vielfältige Bebauung – von den Fachwerkhäusern in Zons über die Siedlungen der Nachkriegszeit bis zu modernen Neubaugebieten – erfordert handwerkliche Vielseitigkeit. Genau das bieten wir: Erfahrung mit allen Gebäudetypen und Materialien, die in Dormagen vorkommen.`,

      localExpertise: `Als Dormagener Unternehmen kennen wir die lokalen Gegebenheiten bestens. Wir wissen, welche Fassadenfarben dem feuchten Rheinlandklima standhalten, welche Materialien für die historischen Gebäude in Zons zugelassen sind und wo in den Neubaugebieten von Horrem oder Hackenbroich welche Bauvorschriften gelten.

Diese lokale Kompetenz spart Ihnen Zeit und Geld. Wir müssen nicht recherchieren, welche Behörde zuständig ist oder welche Auflagen gelten – wir wissen es bereits. Auch bei der Materialauswahl profitieren Sie von unserer Erfahrung: Wir kennen die Stärken und Schwächen verschiedener Produkte unter den spezifischen Bedingungen in Dormagen.

Kurze Wege sind ein weiterer Vorteil. Unser Standort in Dormagen ermöglicht schnelle Reaktionszeiten und minimale Anfahrtskosten. Wenn Sie einen Termin brauchen, sind wir oft schon am nächsten Tag bei Ihnen.`,

      services: `Unser Leistungsangebot deckt alle Anforderungen Dormagener Immobilien ab. Der Innenanstrich – vom einfachen Weißeln bis zur anspruchsvollen Farbgestaltung – ist unser tägliches Brot. Wir verwenden ausschließlich hochwertige Markenfarben, die sowohl optisch überzeugen als auch ein gesundes Raumklima fördern.

Fassadenarbeiten sind in Dormagen besonders wichtig. Das feuchte Klima und die Nähe zum Rhein belasten Außenwände stark. Wir setzen auf bewährte Fassadensysteme, die Feuchtigkeit abweisen und gleichzeitig atmungsaktiv bleiben. So schützen wir Ihr Haus vor Schäden und erhalten den Wert Ihrer Immobilie.

Tapezierarbeiten führen wir ebenfalls professionell durch. Ob klassische Raufaser oder moderne Designertapeten – wir verarbeiten alle Tapetenarten sauber und blasenfrei. Auch das Entfernen alter Tapeten und die Vorbereitung des Untergrunds gehören zu unserem Service.

Für Komplettrenovierungen bieten wir einen Rundum-Service. Von der Planung über die Koordination bis zur Ausführung übernehmen wir alles – Sie haben nur einen Ansprechpartner und können sich zurücklehnen.`,

      process: `Jedes Projekt beginnt mit einem persönlichen Gespräch. Bei einem Vor-Ort-Termin erfassen wir Ihre Wünsche, begutachten die Gegebenheiten und geben erste Empfehlungen. Diese Beratung ist kostenlos und unverbindlich – wir möchten, dass Sie informiert entscheiden können.

Anschließend erhalten Sie ein detailliertes Angebot. Jede Position ist einzeln aufgeführt und nachvollziehbar. Der genannte Preis ist ein Festpreis – Nachforderungen gibt es bei uns nicht, es sei denn, Sie wünschen während der Ausführung zusätzliche Leistungen.

Die Ausführung erfolgt termingerecht und sauber. Wir schützen Ihre Möbel und Böden, achten auf Sauberkeit und räumen am Ende des Arbeitstages auf. Nach Abschluss gehen wir gemeinsam durch die Räume und stellen sicher, dass Sie zufrieden sind.`,

      whyUs: `Warum FarbWelt Service in Dormagen? Weil wir nicht nur arbeiten, sondern hier leben. Unsere Reputation in der Stadt ist uns wichtig – jeder Auftrag ist eine Visitenkarte, die von Nachbarn und Bekannten gesehen wird. Deshalb geben wir bei jedem Projekt unser Bestes.

Viele unserer Dormagener Kunden begleiten wir seit Jahren. Sie rufen uns, wenn eine Renovierung ansteht, empfehlen uns an Freunde weiter und vertrauen auf unsere Arbeit. Diese Treue ist für uns das größte Kompliment und der beste Beweis für die Qualität unserer Leistung.`
    },
    
    serviceHighlights: [
      {
        title: "Innenanstrich Dormagen",
        description: "Professionelles Streichen für alle Räume – vom Keller bis zum Dach.",
        link: "/innenanstrich-dormagen"
      },
      {
        title: "Fassadenanstrich Dormagen",
        description: "Langlebiger Schutz für Ihr Haus im rheinischen Klima.",
        link: "/fassadenarbeiten-dormagen"
      },
      {
        title: "Wohnungsrenovierung",
        description: "Komplett-Service für Ihre Dormagener Wohnung oder Ihr Haus.",
        link: "/renovierung-dormagen"
      },
      {
        title: "Express-Renovierung",
        description: "Schnelle Hilfe bei Umzug oder Wohnungsübergabe.",
        link: "/wohnungsuebergabe-dormagen"
      }
    ],
    
    faq: [
      {
        question: "Was kostet ein Maler in Dormagen pro Quadratmeter?",
        answer: "Die Kosten variieren je nach Leistung. Für einen einfachen Innenanstrich rechnen Sie mit ca. 8-15€ pro m² Wandfläche inklusive Material. Komplexere Arbeiten wie Tapezieren oder Fassadenanstriche liegen entsprechend höher. Wir erstellen Ihnen gerne ein kostenloses Angebot."
      },
      {
        question: "Wie schnell können Sie in Dormagen einen Termin machen?",
        answer: "Als lokaler Betrieb können wir meist innerhalb von 1-2 Wochen mit den Arbeiten beginnen. Für dringende Projekte wie Wohnungsübergaben bieten wir Express-Termine an – oft schon innerhalb weniger Tage."
      },
      {
        question: "Arbeiten Sie in allen Ortsteilen von Dormagen?",
        answer: "Ja, wir sind in ganz Dormagen tätig – von Zons über Nievenheim und Horrem bis nach Stürzelberg und Gohr. Jeder Ortsteil ist für uns gut erreichbar."
      },
      {
        question: "Kennen Sie sich mit den historischen Gebäuden in Zons aus?",
        answer: "Absolut! Die Zollfeste Zons mit ihren denkmalgeschützten Gebäuden ist eines unserer Spezialgebiete. Wir kennen die Auflagen und verwenden zugelassene Materialien für historische Bausubstanz."
      },
      {
        question: "Bieten Sie auch Arbeiten am Wochenende an?",
        answer: "Unsere regulären Arbeitszeiten sind Montag bis Freitag. In Ausnahmefällen, etwa bei Gewerbekunden oder dringenden Terminen, können wir nach Absprache auch samstags arbeiten."
      }
    ],
    
    nearbyAreas: [
      { name: "Nievenheim", slug: "nievenheim" },
      { name: "Zons", slug: "zons" },
      { name: "Horrem", slug: "horrem" },
      { name: "Hackenbroich", slug: "hackenbroich" },
      { name: "Stürzelberg", slug: "stuerzelberg" },
      { name: "Straberg", slug: "straberg" }
    ],
    
    meta: {
      title: "Maler Dormagen | Ihr lokaler Malerbetrieb | FarbWelt Service",
      description: "Professioneller Maler in Dormagen ✓ Lokal & zuverlässig ✓ Innenanstrich ✓ Fassaden ✓ Renovierung. Ihr Handwerkspartner vor Ort. Jetzt Termin buchen!",
      keywords: "Maler Dormagen, Malerbetrieb Dormagen, Malerarbeiten Dormagen, Wohnung streichen Dormagen, Fassade Dormagen"
    }
  },

  // District: Nievenheim
  nievenheim: {
    heroTitle: "Maler in Dormagen-Nievenheim – Ihr Nachbar im Handwerk",
    heroSubtitle: "Professionelle Malerarbeiten im größten Ortsteil Dormagens. Kurze Wege, schnelle Termine, faire Preise.",

    mainContent: {
      intro: `Nievenheim ist das Herz von Dormagen. Der größte Ortsteil mit seinen über 10.000 Einwohnern bietet eine lebendige Mischung aus Wohnen, Arbeiten und Einkaufen. Die zentrale Lage, die gute Infrastruktur und die vielfältige Bebauung machen Nievenheim zu einem beliebten Wohnort für alle Generationen.

Als Malerbetrieb mit Sitz in Dormagen ist Nievenheim praktisch unser Heimatrevier. Wir kennen die Straßen, die Gebäude und viele der Bewohner persönlich. Diese Nähe ermöglicht uns schnelle Reaktionszeiten und eine persönliche Betreuung, die überregionale Anbieter nicht bieten können.`,

      localExpertise: `Nievenheim bietet eine typische Mischung aus verschiedenen Gebäudetypen. Entlang der Kölner Straße und im Ortskern finden sich ältere Gebäude aus der Gründerzeit und der Nachkriegsära. In den Neubaugebieten am Rand entstanden in den letzten Jahrzehnten moderne Einfamilienhäuser und Reihenhäuser.

Wir kennen diese Vielfalt aus hunderten von Projekten. Die soliden Backsteinbauten im älteren Teil erfordern andere Behandlung als die verputzten Neubauten. Die Mehrfamilienhäuser an der Hauptstraße haben andere Anforderungen als die freistehenden Einfamilienhäuser in den Wohngebieten. Für jeden Gebäudetyp haben wir die passende Erfahrung.`,

      services: `Unser Angebot in Nievenheim deckt alle typischen Anforderungen ab. Der Innenanstrich in Wohnungen und Häusern ist unser Kerngeschäft. Wir streichen schnell, sauber und zu fairen Preisen – ideal für Renovierungen, Einzüge oder einfach eine Auffrischung.

Fassadenarbeiten bieten wir für alle Gebäudetypen an. Ob Einfamilienhaus, Doppelhaus oder Mehrfamilienhaus – wir bringen Ihre Fassade in einen gepflegten Zustand und schützen sie langfristig vor Witterungseinflüssen.

Für Vermieter und Hausverwaltungen in Nievenheim bieten wir spezielle Services. Renovierungen bei Mieterwechsel, Treppenhausanstriche, Fassadenpflege – wir sind ein zuverlässiger Partner für regelmäßige Aufträge.`,

      process: `Als Ihr Nachbar im Handwerk sind wir schnell bei Ihnen. Nach Ihrer Anfrage können wir oft schon am nächsten Tag einen Besichtigungstermin anbieten. Die Wege sind kurz, die Reaktionszeiten entsprechend schnell.

Das Angebot erhalten Sie innerhalb weniger Tage. Wir kalkulieren fair und transparent – ohne versteckte Kosten oder überraschende Nachforderungen.

Die Ausführung erfolgt termingerecht und zuverlässig. Als lokaler Betrieb ist uns unser Ruf in Nievenheim besonders wichtig. Deshalb arbeiten wir so, dass Sie uns gerne weiterempfehlen.`,

      whyUs: `Warum FarbWelt Service in Nievenheim? Weil Sie mit uns einen Handwerker vor Ort haben, der auch nach dem Auftrag noch da ist. Wir laufen nicht weg, wenn es Fragen gibt oder eine Nachbesserung nötig ist. Das ist der Vorteil eines lokalen Betriebs gegenüber anonymen Großanbietern.`
    },

    serviceHighlights: [
      {
        title: "Schnelle Termine",
        description: "Als Ihr Nachbar sind wir oft schon morgen bei Ihnen.",
        link: "/renovierung-dormagen"
      },
      {
        title: "Faire Preise",
        description: "Keine Anfahrtskosten, transparente Kalkulation.",
        link: "/renovierung-dormagen"
      },
      {
        title: "Persönliche Betreuung",
        description: "Ein Ansprechpartner für Ihr gesamtes Projekt.",
        link: "/renovierung-dormagen"
      }
    ],

    faq: [
      {
        question: "Wie schnell können Sie in Nievenheim vorbeikommen?",
        answer: "Als lokaler Betrieb können wir meist schon am nächsten Tag einen Besichtigungstermin anbieten. Die Anfahrt dauert nur wenige Minuten."
      },
      {
        question: "Berechnen Sie Anfahrtskosten in Nievenheim?",
        answer: "Nein, für Nievenheim und alle Dormagener Ortsteile berechnen wir keine gesonderten Anfahrtskosten. Die Fahrtzeit ist in unseren Preisen enthalten."
      },
      {
        question: "Arbeiten Sie auch für Hausverwaltungen in Nievenheim?",
        answer: "Ja, wir betreuen mehrere Hausverwaltungen in Nievenheim und Umgebung. Zuverlässige Termine und faire Konditionen sind dabei selbstverständlich."
      }
    ],

    nearbyAreas: [
      { name: "Horrem", slug: "horrem" },
      { name: "Hackenbroich", slug: "hackenbroich" },
      { name: "Delhoven", slug: "delhoven" },
      { name: "Dormagen Mitte", slug: "dormagen-mitte" }
    ],

    meta: {
      title: "Maler Dormagen-Nievenheim | Lokal & Schnell | FarbWelt Service",
      description: "Ihr Maler in Nievenheim ✓ Schnelle Termine ✓ Faire Preise ✓ Persönliche Betreuung. Ihr Nachbar im Handwerk!",
      keywords: "Maler Nievenheim, Maler Dormagen-Nievenheim, Malerarbeiten Nievenheim, Wohnung streichen Nievenheim"
    }
  },

  // District: Zons
  zons: {
    heroTitle: "Maler in Dormagen-Zons – Spezialist für historische Gebäude",
    heroSubtitle: "Professionelle Malerarbeiten in der mittelalterlichen Zollfeste. Denkmalgerechte Ausführung für historische Bausubstanz.",

    mainContent: {
      intro: `Zons ist einzigartig. Die vollständig erhaltene mittelalterliche Zollfeste am Rhein gehört zu den bedeutendsten Baudenkmälern am Niederrhein. Die historischen Stadtmauern, die Fachwerkhäuser und die engen Gassen versetzen Besucher in vergangene Zeiten – und stellen besondere Anforderungen an jeden Handwerker, der hier arbeitet.

Als Malerbetrieb haben wir uns intensiv mit den Besonderheiten von Zons beschäftigt. Die strengen Denkmalschutzauflagen, die historische Bausubstanz und die besonderen Materialanforderungen erfordern spezielles Know-how. Dieses haben wir uns über Jahre erarbeitet und erfolgreich in zahlreichen Projekten angewandt.`,

      localExpertise: `Die historische Bausubstanz in Zons erfordert besondere Materialien und Techniken. Moderne Dispersionsfarben sind in vielen Fällen nicht zugelassen – stattdessen kommen traditionelle Kalkfarben, Silikatfarben oder Leinölprodukte zum Einsatz. Diese Materialien sind diffusionsoffen und erhalten die Atmungsaktivität der alten Mauern.

Wir kennen die Anforderungen des Denkmalschutzes in Zons. Bevor wir arbeiten, klären wir die Auflagen und stimmen unser Vorgehen mit den zuständigen Stellen ab. Bei Bedarf dokumentieren wir unsere Arbeiten für die behördlichen Unterlagen.

Auch außerhalb des historischen Kerns gibt es in Zons Gebäude, die unsere Expertise erfordern. Die Häuser aus der Gründerzeit und der Nachkriegsära haben oft eigene Herausforderungen – von alten Putzschichten bis zu typischen Feuchtigkeitsproblemen in Rheinnähe.`,

      services: `Unser Service in Zons ist auf die besonderen Anforderungen historischer Gebäude ausgerichtet. Der Innenanstrich mit mineralischen Farben gehört zu unserem Standard in denkmalgeschützten Objekten. Diese Farben sind atmungsaktiv, nachhaltig und passen zur historischen Substanz.

Fassadenarbeiten an historischen Gebäuden erfordern besondere Umsicht. Wir verwenden geeignete Materialien, achten auf die Farbgebung im Gesamtensemble und dokumentieren unsere Arbeiten sorgfältig.

Restaurierungsarbeiten bieten wir ebenfalls an. Historische Holzbalken, alte Türen und Fenster können wir fachgerecht aufarbeiten. Wo nötig, arbeiten wir mit spezialisierten Restauratoren zusammen.`,

      process: `In Zons beginnt jedes Projekt mit einer sorgfältigen Analyse. Wir prüfen die Bausubstanz, identifizieren die vorhandenen Materialien und klären die denkmalrechtlichen Anforderungen. Erst dann erstellen wir ein Konzept und ein Angebot.

Bei Arbeiten an denkmalgeschützten Gebäuden koordinieren wir uns mit dem Denkmalschutzamt. Die erforderlichen Genehmigungen holen wir ein oder unterstützen Sie bei der Antragstellung.

Die Ausführung erfolgt mit höchster Sorgfalt. In Zons darf nichts beschädigt werden, was nicht wiederzubeschaffen ist. Deshalb arbeiten wir langsamer und gründlicher als bei Standardobjekten – Qualität geht hier vor Geschwindigkeit.`,

      whyUs: `Warum FarbWelt Service in Zons? Weil wir die Verantwortung verstehen, die mit der Arbeit an historischer Bausubstanz verbunden ist. Wir sind nicht nur Handwerker, sondern Partner bei der Erhaltung des kulturellen Erbes. Das nehmen wir ernst – und das spüren Sie in unserer Arbeit.`
    },

    serviceHighlights: [
      {
        title: "Denkmalschutz-Expertise",
        description: "Erfahrung mit behördlichen Auflagen und historischen Materialien.",
        link: "/renovierung-dormagen"
      },
      {
        title: "Kalk- und Silikatfarben",
        description: "Traditionelle Materialien für historische Bausubstanz.",
        link: "/innenanstrich-dormagen"
      },
      {
        title: "Restaurierung",
        description: "Aufarbeitung historischer Holzelemente und Details.",
        link: "/lackierarbeiten-dormagen"
      }
    ],

    faq: [
      {
        question: "Kennen Sie die Denkmalschutz-Auflagen in Zons?",
        answer: "Ja, wir haben bereits mehrere Projekte in der historischen Zollfeste durchgeführt und kennen die Anforderungen des Denkmalschutzes. Wir verwenden zugelassene Materialien und stimmen uns bei Bedarf mit den Behörden ab."
      },
      {
        question: "Welche Farben verwenden Sie in historischen Gebäuden?",
        answer: "Je nach Objekt und Auflage verwenden wir Kalkfarben, Silikatfarben oder Leinölprodukte. Diese traditionellen Materialien sind diffusionsoffen und für historische Bausubstanz geeignet."
      },
      {
        question: "Dauern Arbeiten in Zons länger als anderswo?",
        answer: "Oft ja, weil wir besonders sorgfältig arbeiten und Zeit für Abstimmungen mit Behörden einplanen müssen. Dafür ist das Ergebnis substanzgerecht und langlebig."
      },
      {
        question: "Können Sie auch moderne Häuser in Zons streichen?",
        answer: "Selbstverständlich. Auch außerhalb des historischen Kerns gibt es Gebäude, die wir mit unseren Standardleistungen betreuen – ohne die besonderen Denkmalschutz-Auflagen."
      }
    ],

    nearbyAreas: [
      { name: "Stürzelberg", slug: "stuerzelberg" },
      { name: "Dormagen Mitte", slug: "dormagen-mitte" },
      { name: "Rheinfeld", slug: "rheinfeld" }
    ],

    meta: {
      title: "Maler Dormagen-Zons | Denkmalschutz & Historie | FarbWelt",
      description: "Spezialist für historische Gebäude in Zons ✓ Denkmalschutz ✓ Kalkfarben ✓ Restaurierung. Fachgerechte Malerarbeiten in der Zollfeste!",
      keywords: "Maler Zons, Denkmalschutz Maler Dormagen, historische Gebäude streichen, Kalkfarben Zons"
    }
  },

  // District: Horrem
  horrem: {
    heroTitle: "Maler in Dormagen-Horrem – Für Ihr Zuhause im Grünen",
    heroSubtitle: "Professionelle Malerarbeiten im familienfreundlichen Horrem. Einfamilienhäuser, Wohnungen und mehr.",

    mainContent: {
      intro: `Horrem ist der familienfreundliche Ortsteil von Dormagen. Die ruhige Lage, die gute Anbindung und die vielen Einfamilienhäuser machen Horrem zu einem beliebten Wohnort für junge Familien und alle, die das Grüne schätzen. Die Bebauung ist überwiegend geprägt von Ein- und Zweifamilienhäusern der 1960er bis 1990er Jahre sowie einigen neueren Neubaugebieten.

Als lokaler Malerbetrieb sind wir in Horrem regelmäßig tätig. Die typischen Horremer Häuser – solide gebaut, gut gepflegt, oft mit Garten – kennen wir aus vielen Projekten. Wir wissen, worauf es bei der Renovierung dieser Gebäude ankommt.`,

      localExpertise: `Die Bebauung in Horrem folgt dem typischen Muster deutscher Vorstädte. Viele Häuser stammen aus den Wirtschaftswunderjahren und sind mit Sorgfalt gebaut. Die Fassaden sind meist verputzt, die Innenräume oft noch mit der originalen Raumaufteilung.

Wir kennen die typischen Herausforderungen dieser Gebäude: Dämmmaßnahmen, die nachträglich ergänzt wurden; Fenster, die ausgetauscht wurden und nun andere Proportionen haben; Bäder und Küchen, die modernisiert wurden. All das berücksichtigen wir bei unserer Arbeit.`,

      services: `Unser Angebot in Horrem ist auf die Bedürfnisse von Eigenheimbesitzern zugeschnitten. Der Innenanstrich im eigenen Haus ist unser Kerngeschäft. Wir streichen Zimmer für Zimmer oder renovieren das ganze Haus in einem Durchgang – ganz nach Ihren Wünschen.

Fassadenarbeiten sind für Hausbesitzer in Horrem besonders wichtig. Eine gepflegte Fassade wertet das ganze Haus auf und schützt die Bausubstanz. Wir bieten Fassadenanstriche, Ausbesserungen und bei Bedarf auch Wärmedämmung an.

Für Komplettrenovierungen bieten wir attraktive Paketpreise. Wenn Sie mehrere Räume oder das ganze Haus streichen lassen, sparen Sie im Vergleich zu Einzelaufträgen.`,

      process: `Unser Service für Horremer Eigenheimbesitzer beginnt mit einer persönlichen Beratung. Wir kommen zu Ihnen, schauen uns die Räume an und besprechen Ihre Vorstellungen. Dabei geben wir auch Tipps zu Farben und Gestaltungsmöglichkeiten.

Das Angebot ist detailliert und transparent. Sie sehen genau, was wir machen und was es kostet. Bei größeren Projekten bieten wir Ratenzahlung an.

Die Ausführung erfolgt rücksichtsvoll und sauber. Wir wissen, dass in einem bewohnten Haus alles etwas anders läuft als auf einer Baustelle. Deshalb räumen wir jeden Abend auf und achten auf Sauberkeit.`,

      whyUs: `Warum FarbWelt Service in Horrem? Weil wir verstehen, was Ihr Zuhause Ihnen bedeutet. Wir behandeln Ihr Haus mit Respekt und arbeiten so, als wäre es unser eigenes. Das ist keine Floskel, sondern unser Selbstverständnis.`
    },

    serviceHighlights: [
      {
        title: "Eigenheim-Service",
        description: "Speziell auf die Bedürfnisse von Hausbesitzern zugeschnitten.",
        link: "/renovierung-dormagen"
      },
      {
        title: "Fassadenpflege",
        description: "Schutz und Verschönerung für Ihr Haus.",
        link: "/fassadenarbeiten-dormagen"
      },
      {
        title: "Paketpreise",
        description: "Attraktive Konditionen für größere Projekte.",
        link: "/renovierung-dormagen"
      }
    ],

    faq: [
      {
        question: "Bieten Sie Paketpreise für ganze Häuser an?",
        answer: "Ja, bei größeren Projekten bieten wir attraktive Paketpreise. Wenn Sie mehrere Räume oder das ganze Haus streichen lassen, wird es pro Quadratmeter günstiger als bei Einzelzimmern."
      },
      {
        question: "Können Sie auch Fassade und Innen zusammen anbieten?",
        answer: "Ja, das ist sogar ideal. Wir können beides koordinieren und Ihnen ein Gesamtpaket schnüren. Das spart Kosten und reduziert den Aufwand für Sie."
      },
      {
        question: "Wie lange dauert die Renovierung eines Einfamilienhauses?",
        answer: "Das hängt vom Umfang ab. Nur Innenanstrich in einem typischen Einfamilienhaus dauert etwa 1-2 Wochen. Mit Fassade entsprechend länger, auch abhängig vom Wetter."
      }
    ],

    nearbyAreas: [
      { name: "Nievenheim", slug: "nievenheim" },
      { name: "Straberg", slug: "straberg" },
      { name: "Hackenbroich", slug: "hackenbroich" }
    ],

    meta: {
      title: "Maler Dormagen-Horrem | Eigenheim & Fassade | FarbWelt Service",
      description: "Ihr Maler in Horrem ✓ Einfamilienhäuser ✓ Fassaden ✓ Paketpreise. Spezialist für Eigenheimbesitzer im Grünen!",
      keywords: "Maler Horrem, Maler Dormagen-Horrem, Haus streichen Horrem, Fassade Horrem"
    }
  },

  // District: Hackenbroich
  hackenbroich: {
    heroTitle: "Maler in Dormagen-Hackenbroich – Kompetent & Nah",
    heroSubtitle: "Professionelle Malerarbeiten im wachsenden Hackenbroich. Neubau, Bestand und alles dazwischen.",

    mainContent: {
      intro: `Hackenbroich ist ein Ortsteil im Wandel. Die zentrale Lage in Dormagen, die gute Verkehrsanbindung und die Nähe zu den Gewerbegebieten machen Hackenbroich attraktiv für Familien und Berufstätige. Neben den älteren Siedlungen entstehen neue Wohngebiete – ein lebendiger Mix aus Alt und Neu.

Als lokaler Malerbetrieb begleiten wir diese Entwicklung. Wir renovieren die Bestandsgebäude aus den 1960er bis 1980er Jahren und führen Erstanstriche in den Neubauten durch. Diese Bandbreite macht unsere Arbeit in Hackenbroich besonders abwechslungsreich.`,

      localExpertise: `Hackenbroich bietet eine typische Mischung aus verschiedenen Bauepochen. Die älteren Siedlungen entlang der Hauptstraßen stammen aus der Nachkriegszeit. In den neueren Gebieten entstanden Reihenhäuser und Mehrfamilienhäuser der 1990er bis 2010er Jahre. Aktuell werden weitere Neubaugebiete erschlossen.

Wir kennen die verschiedenen Gebäudetypen und ihre Anforderungen. Die älteren Häuser haben oft dickere Wände, andere Putzsysteme und manchmal Feuchtigkeitsprobleme. Die neueren Gebäude sind oft mit Wärmedämmverbundsystemen ausgestattet, die spezielle Farben erfordern.`,

      services: `Unser Service in Hackenbroich deckt das gesamte Spektrum ab. Für Neubauten bieten wir Erstanstriche mit wohngesunden Farben, die keine Schadstoffe ausdünsten. Für Bestandsgebäude haben wir die passenden Lösungen für Renovierung und Sanierung.

Auch Gewerbekunden betreuen wir in Hackenbroich. Die Nähe zu den Gewerbegebieten bringt Aufträge für Büros, Werkstätten und Lagerhallen. Wir arbeiten flexibel und bei Bedarf auch außerhalb der Geschäftszeiten.`,

      process: `Unser Ablauf ist auf Effizienz und Qualität ausgelegt. Nach Ihrer Anfrage vereinbaren wir zeitnah einen Termin. Das Angebot erhalten Sie schnell und transparent.

Die Ausführung erfolgt termingerecht und zuverlässig. In Hackenbroich, wo viele Berufspendler wohnen, bieten wir auch flexible Termine am frühen Morgen oder späten Nachmittag an.`,

      whyUs: `Warum FarbWelt Service in Hackenbroich? Weil wir als lokaler Betrieb die Entwicklung des Ortes mitgestalten. Wir sind nicht nur Dienstleister, sondern Teil der Gemeinschaft.`
    },

    serviceHighlights: [
      {
        title: "Neubau & Bestand",
        description: "Kompetenz für alle Gebäudetypen und Baujahre.",
        link: "/renovierung-dormagen"
      },
      {
        title: "Gewerbekunden",
        description: "Flexible Lösungen für Büros und Gewerbeflächen.",
        link: "/renovierung-dormagen"
      },
      {
        title: "Wohngesunde Farben",
        description: "Schadstoffarme Produkte für Neubauten und Familien.",
        link: "/innenanstrich-dormagen"
      }
    ],

    faq: [
      {
        question: "Machen Sie auch Erstanstriche in Neubauten?",
        answer: "Ja, wir führen Erstanstriche in Neubauten durch. Wir verwenden wohngesunde Farben, die keine Schadstoffe ausdünsten und für Familien mit Kindern geeignet sind."
      },
      {
        question: "Arbeiten Sie auch für Gewerbekunden in Hackenbroich?",
        answer: "Ja, wir betreuen auch Büros, Werkstätten und andere Gewerbeflächen. Wir arbeiten flexibel und können Termine außerhalb der Geschäftszeiten anbieten."
      },
      {
        question: "Kennen Sie sich mit Wärmedämmverbundsystemen aus?",
        answer: "Ja, viele neuere Gebäude in Hackenbroich haben WDVS-Fassaden. Wir verwenden die passenden Farben und Techniken für diese Oberflächen."
      }
    ],

    nearbyAreas: [
      { name: "Nievenheim", slug: "nievenheim" },
      { name: "Horrem", slug: "horrem" },
      { name: "Dormagen Mitte", slug: "dormagen-mitte" }
    ],

    meta: {
      title: "Maler Dormagen-Hackenbroich | Neubau & Bestand | FarbWelt",
      description: "Ihr Maler in Hackenbroich ✓ Neubau ✓ Renovierung ✓ Gewerbe. Kompetenz für alle Gebäudetypen!",
      keywords: "Maler Hackenbroich, Maler Dormagen-Hackenbroich, Neubau Maler, Gewerbe Maler Dormagen"
    }
  },

  // District: Stürzelberg
  stuerzelberg: {
    heroTitle: "Maler in Dormagen-Stürzelberg – Idylle am Rhein",
    heroSubtitle: "Professionelle Malerarbeiten im malerischen Stürzelberg. Ihr Handwerker für das Rheindorf.",

    mainContent: {
      intro: `Stürzelberg ist Dormagens Idylle am Rhein. Der kleine Ortsteil am Rheinufer besticht durch seinen dörflichen Charakter, die historischen Gebäude und die Nähe zur Natur. Wer hier wohnt, schätzt die Ruhe, die Gemeinschaft und das besondere Flair eines echten Rheindorfes.

Als Malerbetrieb kommen wir gerne nach Stürzelberg. Die gepflegten Häuser, die freundlichen Bewohner und die besondere Atmosphäre machen jeden Auftrag hier zu etwas Besonderem.`,

      localExpertise: `Stürzelberg ist geprägt von seiner Lage am Rhein und seiner Geschichte als Fischer- und Bauerndorf. Im Ortskern finden sich noch historische Gebäude – teils denkmalgeschützt, teils liebevoll saniert. Drumherum gruppieren sich neuere Einfamilienhäuser und Siedlungen.

Die Rheinnähe bringt besondere Anforderungen mit sich. Die hohe Luftfeuchtigkeit belastet Fassaden stärker als anderswo. Wir verwenden entsprechend robuste Materialien, die diesen Bedingungen standhalten.`,

      services: `Unser Service in Stürzelberg ist auf die Besonderheiten des Ortes abgestimmt. Für die historischen Gebäude bieten wir denkmalgerechte Materialien und Techniken. Für die neueren Häuser gelten unsere Standard-Qualitätsleistungen.

Fassadenarbeiten sind in Stürzelberg besonders wichtig. Die Rheinlage erfordert regelmäßige Pflege, um Algen, Pilze und Witterungsschäden zu vermeiden. Wir bieten entsprechende Schutzanstriche an.`,

      process: `In Stürzelberg nehmen wir uns Zeit. Die kurzen Wege im Ort ermöglichen unkomplizierte Abstimmungen. Wir arbeiten so, dass der dörfliche Charakter erhalten bleibt und Nachbarn nicht gestört werden.`,

      whyUs: `Warum FarbWelt Service in Stürzelberg? Weil wir den besonderen Charakter dieses Ortes schätzen und unsere Arbeit entsprechend ausrichten. In Stürzelberg geht es nicht nur um Streichen, sondern um die Pflege einer einzigartigen Dorfgemeinschaft.`
    },

    serviceHighlights: [
      {
        title: "Rheinfeste Fassaden",
        description: "Spezielle Schutzanstriche für die feuchte Rheinlage.",
        link: "/fassadenarbeiten-dormagen"
      },
      {
        title: "Historische Gebäude",
        description: "Erfahrung mit denkmalgeschützten Objekten im Ortskern.",
        link: "/renovierung-dormagen"
      },
      {
        title: "Persönlicher Service",
        description: "Ihr Handwerker vor Ort im Rheindorf.",
        link: "/renovierung-dormagen"
      }
    ],

    faq: [
      {
        question: "Kennen Sie die historischen Gebäude in Stürzelberg?",
        answer: "Ja, wir haben bereits an mehreren älteren Gebäuden in Stürzelberg gearbeitet. Wir kennen die Anforderungen und verwenden geeignete Materialien."
      },
      {
        question: "Wie gehen Sie mit der Rhein-Feuchtigkeit um?",
        answer: "Wir verwenden spezielle Fassadenfarben mit fungiziden Zusätzen, die Algen und Pilzbefall vorbeugen. Bei Bedarf behandeln wir bestehenden Befall vor dem Neuanstrich."
      },
      {
        question: "Arbeiten Sie auch am Wochenende in Stürzelberg?",
        answer: "In der Regel nicht, um die Ruhe des Dorfes nicht zu stören. In Ausnahmefällen und nach Absprache mit Ihnen und den Nachbarn ist aber manches möglich."
      }
    ],

    nearbyAreas: [
      { name: "Zons", slug: "zons" },
      { name: "Dormagen Mitte", slug: "dormagen-mitte" },
      { name: "Rheinfeld", slug: "rheinfeld" }
    ],

    meta: {
      title: "Maler Dormagen-Stürzelberg | Rheindorf | FarbWelt Service",
      description: "Ihr Maler in Stürzelberg ✓ Rheinfeste Fassaden ✓ Historische Gebäude ✓ Persönlicher Service im Rheindorf!",
      keywords: "Maler Stürzelberg, Maler Dormagen-Stürzelberg, Fassade Rhein, Rheindorf Maler"
    }
  },

  // District: Straberg
  straberg: {
    heroTitle: "Maler in Dormagen-Straberg – Ländlich & Verlässlich",
    heroSubtitle: "Professionelle Malerarbeiten im ländlichen Straberg. Ihr Handwerkspartner zwischen Feldern und Wäldern.",

    mainContent: {
      intro: `Straberg ist Dormagens ländliche Seite. Der Ortsteil am östlichen Rand der Stadt bewahrt sich seinen dörflichen Charakter mit Bauernhöfen, Pferdekoppeln und viel Grün. Wer hier wohnt, genießt die Ruhe und die Nähe zur Natur – ohne auf die Vorteile einer guten Infrastruktur verzichten zu müssen.

Als Malerbetrieb kommen wir gerne nach Straberg. Die Mischung aus historischen Hofanlagen, klassischen Einfamilienhäusern und neueren Bauten bietet abwechslungsreiche Aufgaben.`,

      localExpertise: `Straberg ist geprägt von seiner landwirtschaftlichen Vergangenheit. Im Ortskern finden sich noch alte Bauernhöfe und Fachwerkhäuser. Drumherum entstanden in den letzten Jahrzehnten Einfamilienhäuser für Familien, die das Landleben schätzen.

Die größeren Gebäude – Bauernhöfe, Scheunen, landwirtschaftliche Gebäude – erfordern oft andere Techniken als normale Wohnhäuser. Wir haben Erfahrung mit diesen Objekten und können auch größere Fassadenflächen effizient bearbeiten.`,

      services: `Unser Service in Straberg reicht vom kleinen Einfamilienhaus bis zum großen Hof. Innenanstriche führen wir in allen Gebäudetypen durch. Bei landwirtschaftlichen Gebäuden verwenden wir robuste Farben, die den besonderen Belastungen standhalten.

Fassadenarbeiten bieten wir für alle Größen an. Ob kleines Wohnhaus oder große Scheune – wir haben die Ausrüstung und Erfahrung für jedes Projekt.`,

      process: `In Straberg planen wir Projekte besonders sorgfältig. Die Anfahrt ist etwas länger, deshalb bündeln wir Material und Personal effizient. Bei größeren Projekten sind wir auch mehrere Wochen vor Ort.`,

      whyUs: `Warum FarbWelt Service in Straberg? Weil wir das Landleben verstehen und respektieren. Wir kommen mit den Gegebenheiten zurecht und arbeiten so, dass der ländliche Charakter erhalten bleibt.`
    },

    serviceHighlights: [
      {
        title: "Große Flächen",
        description: "Erfahrung mit Bauernhöfen, Scheunen und landwirtschaftlichen Gebäuden.",
        link: "/fassadenarbeiten-dormagen"
      },
      {
        title: "Historische Hofanlagen",
        description: "Fachgerechte Behandlung von Fachwerk und alten Gebäuden.",
        link: "/renovierung-dormagen"
      },
      {
        title: "Robuste Materialien",
        description: "Langlebige Farben für beanspruchte Oberflächen.",
        link: "/fassadenarbeiten-dormagen"
      }
    ],

    faq: [
      {
        question: "Können Sie auch große Scheunen und Ställe streichen?",
        answer: "Ja, wir haben Erfahrung mit größeren landwirtschaftlichen Gebäuden. Wir verfügen über die nötige Ausrüstung und können auch große Flächen effizient bearbeiten."
      },
      {
        question: "Welche Farben verwenden Sie für landwirtschaftliche Gebäude?",
        answer: "Wir verwenden robuste Farben, die mechanischer Belastung, Feuchtigkeit und landwirtschaftlichen Einflüssen standhalten. Bei Bedarf auch spezielle Produkte für Stallungen."
      },
      {
        question: "Berechnen Sie Anfahrtskosten nach Straberg?",
        answer: "Straberg gehört zu unserem regulären Einzugsgebiet. Bei normalen Projekten berechnen wir keine gesonderten Anfahrtskosten."
      }
    ],

    nearbyAreas: [
      { name: "Horrem", slug: "horrem" },
      { name: "Gohr", slug: "gohr" },
      { name: "Nievenheim", slug: "nievenheim" }
    ],

    meta: {
      title: "Maler Dormagen-Straberg | Ländlich | FarbWelt Service",
      description: "Ihr Maler in Straberg ✓ Bauernhöfe ✓ Große Flächen ✓ Robuste Materialien. Handwerk fürs Landleben!",
      keywords: "Maler Straberg, Maler Dormagen-Straberg, Bauernhof streichen, Scheune Maler"
    }
  },

  // District: Dormagen-Mitte
  mitte: {
    heroTitle: "Maler in Dormagen-Mitte – Ihr Partner im Stadtzentrum",
    heroSubtitle: "Professionelle Malerarbeiten im Herzen von Dormagen. Vom Historischen Rathaus bis zur City – wir sind direkt vor Ort.",

    mainContent: {
      intro: `Dormagen-Mitte ist das pulsierende Herz der Stadt. Hier treffen Geschichte und Moderne aufeinander – das historische Rathaus, die Einkaufsmeile an der Kölner Straße und die zahlreichen Geschäfte prägen das Stadtbild. Als Malerbetrieb im Zentrum Dormagens sind wir täglich in diesem Bereich unterwegs und kennen die besonderen Anforderungen von Wohn- und Geschäftsgebäuden in der Innenstadt.

Die Bebauung in Dormagen-Mitte ist vielfältig: Von den älteren Geschäftshäusern über Nachkriegsbauten bis zu moderneren Wohn- und Geschäftsgebäuden findet sich hier ein bunter Mix. Diese Vielfalt erfordert einen Malerbetrieb, der flexibel auf unterschiedliche Gebäudetypen eingehen kann – und genau das bieten wir.`,

      localExpertise: `Das Zentrum von Dormagen hat seine eigenen Herausforderungen. Die Nähe zu Geschäften und Passanten erfordert sauberes, rücksichtsvolles Arbeiten. Parkplätze sind oft knapp, die Anlieferung von Material muss gut geplant sein. Wir kennen diese Gegebenheiten und planen unsere Einsätze entsprechend.

Für Geschäftskunden in der Innenstadt bieten wir flexible Arbeitszeiten an. Renovierungen in Ladenlokalen führen wir gerne außerhalb der Öffnungszeiten durch, um den Geschäftsbetrieb nicht zu stören. Auch bei Wohnungen über Ladengeschäften achten wir auf die besonderen Umstände.`,

      services: `Unser Angebot für Dormagen-Mitte umfasst sowohl private als auch gewerbliche Malerarbeiten. Wohnungsrenovierungen, Fassadenanstriche und Innenraumgestaltung gehören zu unserem täglichen Geschäft. Für Ladengeschäfte bieten wir individuelle Konzepte, die Ihre Marke unterstreichen.

Die Fassadenpflege in der Innenstadt ist besonders wichtig. Ein gepflegtes Erscheinungsbild wirkt sich direkt auf den Wert Ihrer Immobilie und die Attraktivität Ihres Geschäfts aus. Wir sorgen dafür, dass Ihre Fassade stets einen guten Eindruck macht.`,

      process: `In Dormagen-Mitte profitieren Sie von unserer Nähe. Besichtigungstermine können oft kurzfristig vereinbart werden. Die Anlieferung von Material planen wir so, dass keine Behinderungen entstehen. Bei Gewerbekunden stimmen wir die Arbeitszeiten individuell ab.`,

      whyUs: `Als Dormagener Betrieb ist uns das Erscheinungsbild unserer Innenstadt wichtig. Jedes Projekt hier ist auch eine Referenz, die täglich von vielen Menschen gesehen wird. Deshalb geben wir in Dormagen-Mitte immer unser Bestes.`
    },

    serviceHighlights: [
      {
        title: "Gewerbemalerei",
        description: "Professionelle Gestaltung von Ladengeschäften und Büros.",
        link: "/renovierung-dormagen"
      },
      {
        title: "Flexible Zeiten",
        description: "Arbeiten außerhalb der Geschäftszeiten möglich.",
        link: "/renovierung-dormagen"
      },
      {
        title: "City-Service",
        description: "Schnelle Termine im Stadtzentrum.",
        link: "/innenanstrich-dormagen"
      }
    ],

    faq: [
      {
        question: "Arbeiten Sie auch in Geschäftsräumen in der Innenstadt?",
        answer: "Ja, wir betreuen zahlreiche Geschäftskunden in Dormagen-Mitte. Auf Wunsch arbeiten wir außerhalb der Öffnungszeiten, um Ihren Betrieb nicht zu stören."
      },
      {
        question: "Wie gehen Sie mit den beengten Verhältnissen in der Innenstadt um?",
        answer: "Wir planen unsere Einsätze sorgfältig – von der Materialanlieferung bis zum Parken. Unsere Mitarbeiter sind erfahren im Umgang mit innerstädtischen Gegebenheiten."
      },
      {
        question: "Können Sie auch Schaufenster-Beschriftungen entfernen?",
        answer: "Ja, das Entfernen alter Beschriftungen und die Vorbereitung von Flächen für neue Gestaltungen gehört zu unserem Service."
      }
    ],

    nearbyAreas: [
      { name: "Nievenheim", slug: "nievenheim" },
      { name: "Hackenbroich", slug: "hackenbroich" },
      { name: "Horrem", slug: "horrem" }
    ],

    meta: {
      title: "Maler Dormagen-Mitte | Innenstadt & Gewerbe | FarbWelt Service",
      description: "Ihr Maler in Dormagen-Mitte ✓ Gewerbe ✓ Wohnung ✓ Flexible Zeiten. Professionelle Malerarbeiten im Stadtzentrum!",
      keywords: "Maler Dormagen-Mitte, Maler Innenstadt Dormagen, Gewerbemalerei Dormagen"
    }
  },

  // District: Rheinfeld
  rheinfeld: {
    heroTitle: "Maler in Dormagen-Rheinfeld – Qualität am Rhein",
    heroSubtitle: "Professionelle Malerarbeiten im Chemiepark-nahen Rheinfeld. Wohnen und Gewerbe in bester Lage.",

    mainContent: {
      intro: `Rheinfeld liegt strategisch günstig zwischen Dormagen und dem Rhein. Der Stadtteil ist geprägt von seiner Nähe zum Chempark und bietet eine Mischung aus Wohngebieten und gewerblicher Nutzung. Die gute Verkehrsanbindung macht Rheinfeld zu einem attraktiven Standort für Pendler und Unternehmen gleichermaßen.

Als lokaler Malerbetrieb betreuen wir sowohl die Wohngebäude als auch Gewerbeobjekte in Rheinfeld. Die industrielle Nachbarschaft stellt manchmal besondere Anforderungen an Fassadenschutz und Reinigung – wir kennen diese Gegebenheiten und haben die passenden Lösungen.`,

      localExpertise: `Rheinfeld bietet eine interessante Mischung aus verschiedenen Gebäudetypen. Neben den Wohnsiedlungen gibt es Gewerbeflächen und vereinzelt auch ältere Gebäude. Die Nähe zum Chempark bedeutet, dass Fassaden manchmal stärkerer Belastung ausgesetzt sind als in anderen Stadtteilen.

Wir kennen die besonderen Anforderungen und setzen bei Bedarf auf besonders widerstandsfähige Farben und Beschichtungen. So bleibt Ihre Fassade auch unter schwierigeren Bedingungen lange schön.`,

      services: `Unser Service in Rheinfeld umfasst alle Malerarbeiten für Privat und Gewerbe. Der Innenanstrich in Wohnhäusern und Wohnungen ist unser Kerngeschäft. Für Gewerbeobjekte bieten wir zusätzlich Spezialbeschichtungen und Industrieanstriche an.

Fassadenarbeiten führen wir mit robusten Materialien durch, die der industriellen Umgebung standhalten. Regelmäßige Fassadenpflege kann hier besonders sinnvoll sein, um Ablagerungen rechtzeitig zu entfernen.`,

      process: `In Rheinfeld arbeiten wir effizient und termingerecht. Die gute Erreichbarkeit des Stadtteils ermöglicht uns flexible Einsatzplanung. Bei Gewerbeprojekten stimmen wir uns eng mit Ihnen ab, um Betriebsabläufe nicht zu stören.`,

      whyUs: `In Rheinfeld profitieren Sie von unserem Know-how bei anspruchsvollen Umgebungsbedingungen. Wir wissen, welche Produkte hier am besten funktionieren und wie wir Ihre Immobilie optimal schützen.`
    },

    serviceHighlights: [
      {
        title: "Industrienahe Lösungen",
        description: "Robuste Beschichtungen für anspruchsvolle Umgebungen.",
        link: "/fassadenarbeiten-dormagen"
      },
      {
        title: "Gewerbe & Privat",
        description: "Kompetenz für alle Gebäudetypen in Rheinfeld.",
        link: "/renovierung-dormagen"
      },
      {
        title: "Fassadenschutz",
        description: "Langlebige Anstriche für belastete Fassaden.",
        link: "/fassadenarbeiten-dormagen"
      }
    ],

    faq: [
      {
        question: "Haben Sie Erfahrung mit industrienahen Gebäuden?",
        answer: "Ja, wir kennen die besonderen Anforderungen von Gebäuden in der Nähe des Chemparks und setzen bei Bedarf auf besonders widerstandsfähige Materialien."
      },
      {
        question: "Bieten Sie auch Industrieanstriche an?",
        answer: "Ja, für Gewerbeobjekte bieten wir auch Spezialbeschichtungen und Industrieanstriche an. Sprechen Sie uns auf Ihre konkreten Anforderungen an."
      },
      {
        question: "Wie oft sollte man die Fassade in Rheinfeld streichen lassen?",
        answer: "Das hängt von der Belastung ab. In industrienahen Lagen empfehlen wir eine regelmäßige Prüfung alle 5-7 Jahre und bei Bedarf eine Auffrischung."
      }
    ],

    nearbyAreas: [
      { name: "Stürzelberg", slug: "stuerzelberg" },
      { name: "Zons", slug: "zons" },
      { name: "Dormagen Mitte", slug: "mitte" }
    ],

    meta: {
      title: "Maler Dormagen-Rheinfeld | Industrie & Wohnen | FarbWelt Service",
      description: "Ihr Maler in Rheinfeld ✓ Industrienahe Lösungen ✓ Fassadenschutz ✓ Wohnung & Gewerbe. Robuste Qualität!",
      keywords: "Maler Rheinfeld, Maler Dormagen-Rheinfeld, Industriemaler Dormagen"
    }
  },

  // District: Delrath
  delrath: {
    heroTitle: "Maler in Dormagen-Delrath – Handwerk im Grünen",
    heroSubtitle: "Professionelle Malerarbeiten im beschaulichen Delrath. Ihr Malerbetrieb für Einfamilienhäuser und mehr.",

    mainContent: {
      intro: `Delrath ist einer der kleineren, aber feinen Ortsteile von Dormagen. Die ruhige Lage, die ländliche Umgebung und die übersichtliche Bebauung machen Delrath zu einem beliebten Wohnort für alle, die das Grüne schätzen. Hier dominieren Einfamilienhäuser und kleinere Wohnanlagen das Bild.

Als lokaler Malerbetrieb kommen wir gerne nach Delrath. Die persönliche Atmosphäre des kleinen Ortes passt zu unserem Verständnis von Handwerk: individuell, sorgfältig und mit Liebe zum Detail.`,

      localExpertise: `Delrath ist geprägt von gut gepflegten Einfamilienhäusern und gepflegten Gärten. Die Bewohner legen Wert auf ein ansprechendes Erscheinungsbild ihrer Immobilien. Wir unterstützen diesen Anspruch mit qualitativ hochwertigen Malerarbeiten, die zum Gesamtbild des Ortes passen.

Die Bebauung ist überwiegend aus der Nachkriegszeit und den folgenden Jahrzehnten. Viele Häuser wurden über die Jahre liebevoll modernisiert und gepflegt. Wir kennen diese Gebäudetypen und wissen, worauf es bei der Renovierung ankommt.`,

      services: `Unser Angebot für Delrath konzentriert sich auf die typischen Bedürfnisse von Eigenheimbesitzern. Der Innenanstrich, oft verbunden mit einer Modernisierung einzelner Räume, ist häufig nachgefragt. Fassadenanstriche gehören ebenfalls zu unserem Kerngeschäft.

Für die älteren Häuser in Delrath bieten wir auch energetische Beratung an. Ein neuer Fassadenanstrich lässt sich oft gut mit Wärmedämmmaßnahmen verbinden – wir koordinieren das gerne für Sie.`,

      process: `In Delrath schätzen wir die persönliche Beratung besonders. Oft entstehen hier langfristige Kundenbeziehungen, weil wir nicht nur einmal, sondern über Jahre hinweg für unsere Kunden da sind. Das ist für uns Handwerk, wie es sein soll.`,

      whyUs: `In Delrath arbeiten wir besonders gerne, weil hier noch die persönliche Beziehung zählt. Wir sind nicht der anonyme Großbetrieb, sondern Ihr Handwerker von nebenan.`
    },

    serviceHighlights: [
      {
        title: "Eigenheim-Service",
        description: "Speziell auf Einfamilienhäuser zugeschnitten.",
        link: "/renovierung-dormagen"
      },
      {
        title: "Langfristige Betreuung",
        description: "Wir sind über Jahre für Sie da.",
        link: "/renovierung-dormagen"
      },
      {
        title: "Energieberatung",
        description: "Fassade und Wärmedämmung aus einer Hand.",
        link: "/fassadenarbeiten-dormagen"
      }
    ],

    faq: [
      {
        question: "Kennen Sie sich mit den Häusern in Delrath aus?",
        answer: "Ja, wir haben in Delrath bereits zahlreiche Projekte umgesetzt und kennen die typischen Gebäudetypen und ihre Anforderungen."
      },
      {
        question: "Bieten Sie auch Wärmedämmung an?",
        answer: "Wir können Wärmedämmarbeiten koordinieren und mit dem Fassadenanstrich verbinden. Sprechen Sie uns auf eine Energieberatung an."
      },
      {
        question: "Wie schnell können Sie in Delrath vorbeikommen?",
        answer: "Als lokaler Betrieb können wir meist innerhalb weniger Tage einen Besichtigungstermin anbieten."
      }
    ],

    nearbyAreas: [
      { name: "Gohr", slug: "gohr" },
      { name: "Hackenbroich", slug: "hackenbroich" },
      { name: "Nievenheim", slug: "nievenheim" }
    ],

    meta: {
      title: "Maler Dormagen-Delrath | Eigenheim & Fassade | FarbWelt Service",
      description: "Ihr Maler in Delrath ✓ Einfamilienhäuser ✓ Persönlicher Service ✓ Langfristige Betreuung!",
      keywords: "Maler Delrath, Maler Dormagen-Delrath, Haus streichen Delrath"
    }
  },

  // District: Gohr
  gohr: {
    heroTitle: "Maler in Dormagen-Gohr – Tradition trifft Handwerk",
    heroSubtitle: "Professionelle Malerarbeiten im ländlichen Gohr. Ihr Malerbetrieb für den Dormagener Osten.",

    mainContent: {
      intro: `Gohr liegt am östlichen Rand von Dormagen und hat sich seinen ländlichen Charakter bewahrt. Der Ortsteil ist geprägt von Landwirtschaft, Pferdehöfen und einer überschaubaren Wohnbebauung. Wer hier lebt, schätzt die Ruhe, die Natur und die Gemeinschaft eines gewachsenen Dorfes.

Als Malerbetrieb mit Wurzeln in der Region kommen wir gerne nach Gohr. Die Mischung aus alten Hofanlagen, klassischen Einfamilienhäusern und neueren Bauten bietet abwechslungsreiche Projekte.`,

      localExpertise: `Gohr hat eine besondere Mischung aus alter und neuer Bausubstanz. Die historischen Höfe erfordern oft sensibles Vorgehen – hier kommen manchmal traditionelle Materialien zum Einsatz. Die neueren Wohnhäuser entsprechen dem üblichen Standard, den wir aus anderen Dormagener Ortsteilen kennen.

Die ländliche Lage bringt besondere Anforderungen mit sich. Größere Grundstücke, teils längere Zufahrten und die Nähe zu landwirtschaftlichen Flächen prägen das Arbeitsumfeld. Wir sind darauf eingestellt und planen entsprechend.`,

      services: `Unser Leistungsangebot in Gohr ist breit gefächert. Vom einfachen Innenanstrich über Fassadenarbeiten bis zur Renovierung historischer Gebäudeteile decken wir alles ab. Für landwirtschaftliche Gebäude bieten wir robuste Lösungen an.

Die Pflege historischer Bausubstanz ist in Gohr immer wieder gefragt. Alte Holzbalken, Fachwerk und traditionelle Putze erfordern besonderes Know-how. Wir haben Erfahrung mit diesen Materialien und behandeln sie mit der gebotenen Sorgfalt.`,

      process: `In Gohr nehmen wir uns Zeit für eine gründliche Beratung. Die besonderen Gegebenheiten vor Ort – sei es ein historisches Gebäude oder ein weitläufiges Grundstück – berücksichtigen wir von Anfang an in unserer Planung.`,

      whyUs: `Gohr passt zu unserem Selbstverständnis als traditioneller Handwerksbetrieb. Hier zählt noch persönliche Beziehung, solide Arbeit und Verlässlichkeit. Genau das bieten wir.`
    },

    serviceHighlights: [
      {
        title: "Historische Gebäude",
        description: "Erfahrung mit alten Höfen und Fachwerk.",
        link: "/renovierung-dormagen"
      },
      {
        title: "Landwirtschaft",
        description: "Robuste Lösungen für Scheunen und Ställe.",
        link: "/fassadenarbeiten-dormagen"
      },
      {
        title: "Traditionelles Handwerk",
        description: "Sorgfältige Arbeit mit bewährten Techniken.",
        link: "/innenanstrich-dormagen"
      }
    ],

    faq: [
      {
        question: "Haben Sie Erfahrung mit alten Hofanlagen?",
        answer: "Ja, wir haben bereits mehrere historische Höfe in der Region renoviert und kennen die besonderen Anforderungen von Fachwerk, alten Putzen und historischen Holzelementen."
      },
      {
        question: "Streichen Sie auch landwirtschaftliche Gebäude?",
        answer: "Ja, Scheunen, Ställe und Wirtschaftsgebäude gehören zu unserem Leistungsspektrum. Wir verwenden robuste Materialien, die den besonderen Belastungen standhalten."
      },
      {
        question: "Berechnen Sie Anfahrtskosten nach Gohr?",
        answer: "Nein, Gohr gehört zu unserem regulären Einzugsgebiet. Bei normalen Projekten sind keine gesonderten Anfahrtskosten fällig."
      }
    ],

    nearbyAreas: [
      { name: "Straberg", slug: "straberg" },
      { name: "Delrath", slug: "delrath" },
      { name: "Nievenheim", slug: "nievenheim" }
    ],

    meta: {
      title: "Maler Dormagen-Gohr | Höfe & Tradition | FarbWelt Service",
      description: "Ihr Maler in Gohr ✓ Historische Gebäude ✓ Landwirtschaft ✓ Traditionelles Handwerk!",
      keywords: "Maler Gohr, Maler Dormagen-Gohr, Bauernhof streichen, Fachwerk Maler"
    }
  },

  // District: Delhoven
  delhoven: {
    heroTitle: "Maler in Dormagen-Delhoven – Ihr Nachbar im Handwerk",
    heroSubtitle: "Professionelle Malerarbeiten im wachsenden Delhoven. Qualität für Alt- und Neubau.",

    mainContent: {
      intro: `Delhoven ist ein aufstrebender Ortsteil von Dormagen. Die Nähe zur Innenstadt, die gute Infrastruktur und die Mischung aus gewachsener Bebauung und neuen Wohngebieten machen Delhoven zu einem beliebten Wohnort. Hier leben Familien, Berufstätige und Senioren in einem lebendigen Miteinander.

Als lokaler Malerbetrieb begleiten wir die Entwicklung von Delhoven aktiv. Wir renovieren die Bestandsgebäude und führen Erstanstriche in den Neubauten durch – ein breites Spektrum, das unsere Vielseitigkeit widerspiegelt.`,

      localExpertise: `Delhoven bietet eine interessante Mischung aus verschiedenen Gebäudetypen. Die älteren Siedlungen stammen aus der Nachkriegszeit und den folgenden Jahrzehnten. In den neueren Gebieten entstehen moderne Einfamilienhäuser und Reihenhäuser. Diese Vielfalt erfordert einen Malerbetrieb, der sich auf unterschiedliche Anforderungen einstellen kann.

Wir kennen die verschiedenen Bauphasen und ihre typischen Merkmale. Die älteren Häuser haben oft andere Putzstrukturen und Untergründe als die Neubauten. Für jeden Typ haben wir die passende Erfahrung.`,

      services: `Unser Angebot in Delhoven deckt alle Anforderungen ab. Für Bestandsgebäude bieten wir Renovierung und Modernisierung. Für Neubauten führen wir Erstanstriche mit wohngesunden Farben durch. Fassadenarbeiten gehören bei beiden Gebäudetypen zu unserem Programm.

Besonders gefragt in Delhoven: unsere Komplett-Renovierungen bei Eigentümerwechsel. Wenn Sie ein bestehendes Haus gekauft haben und es vor dem Einzug auffrischen möchten, sind wir der richtige Partner.`,

      process: `In Delhoven profitieren Sie von unserer lokalen Präsenz. Kurze Wege, schnelle Reaktionszeiten und persönliche Betreuung sind für uns selbstverständlich. Wir sind Ihr Handwerker vor Ort, nicht ein anonymer Dienstleister.`,

      whyUs: `In Delhoven arbeiten wir gerne, weil wir die Gemeinschaft hier kennen und schätzen. Viele unserer Kunden sind durch Empfehlung auf uns aufmerksam geworden – und empfehlen uns selbst weiter.`
    },

    serviceHighlights: [
      {
        title: "Neubau & Bestand",
        description: "Kompetenz für alle Gebäudetypen in Delhoven.",
        link: "/renovierung-dormagen"
      },
      {
        title: "Einzugsrenovierung",
        description: "Komplett-Service vor dem Einzug ins neue Zuhause.",
        link: "/renovierung-dormagen"
      },
      {
        title: "Wohngesunde Farben",
        description: "Schadstoffarm und familienfreundlich.",
        link: "/innenanstrich-dormagen"
      }
    ],

    faq: [
      {
        question: "Arbeiten Sie auch in den Neubaugebieten von Delhoven?",
        answer: "Ja, wir führen Erstanstriche in Neubauten durch und verwenden dabei wohngesunde, schadstoffarme Farben."
      },
      {
        question: "Können Sie ein Haus vor dem Einzug komplett renovieren?",
        answer: "Ja, Einzugsrenovierungen sind unser Spezialgebiet. Wir koordinieren alle Malerarbeiten und übergeben Ihnen Ihr neues Zuhause bezugsfertig."
      },
      {
        question: "Wie schnell können Sie in Delhoven starten?",
        answer: "Als lokaler Betrieb können wir meist innerhalb von 1-2 Wochen mit den Arbeiten beginnen. Bei dringenden Projekten bemühen wir uns um schnellere Termine."
      }
    ],

    nearbyAreas: [
      { name: "Nievenheim", slug: "nievenheim" },
      { name: "Hackenbroich", slug: "hackenbroich" },
      { name: "Dormagen Mitte", slug: "mitte" }
    ],

    meta: {
      title: "Maler Dormagen-Delhoven | Neubau & Renovierung | FarbWelt Service",
      description: "Ihr Maler in Delhoven ✓ Neubau ✓ Bestand ✓ Einzugsrenovierung. Ihr Nachbar im Handwerk!",
      keywords: "Maler Delhoven, Maler Dormagen-Delhoven, Neubau Maler, Renovierung Delhoven"
    }
  }
};

export default seoContentDormagen;
